import {
  Basic,
  Extras,
  Group,
  InsuranceBuildingResp,
  InsuranceDoors,
  InsurancePersonal,
  StepsIconHouse,
} from '@/icons'

export const icons = {
  household: <InsuranceDoors color="secondary.500" />,
  property: <StepsIconHouse color="secondary.500" />,
  common: <Group color="secondary.500" />,
  lifeLiability: <InsurancePersonal color="secondary.500" />,
  propertyLiability: <InsuranceBuildingResp color="secondary.500" />,
  travelBasic: <Basic color="secondary.500" />,
  extras: <Extras color="secondary.500" />,
}
